export default __webpack_public_path__ + "static/media/omnigear.0ec7b431.png";